import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_NAME = 'Jejaring Alumni PIMNAS Indonesia';

const PAGE_TITLES = {
  '/': SITE_NAME,
  '/alumni': `Direktori Alumni — ${SITE_NAME}`,
  '/statistik': `Statistik Alumni — ${SITE_NAME}`,
  '/berita': `Berita & Artikel — ${SITE_NAME}`,
  '/proyek': `Proyek Kolaborasi — ${SITE_NAME}`,
  '/tentang': `Tentang Kami — ${SITE_NAME}`,
  '/ajukan-alumni': `Ajukan Diri sebagai Alumni — ${SITE_NAME}`,
  '/login': `Login Admin — ${SITE_NAME}`,
};

const usePageTitle = (customTitle) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (customTitle) {
      document.title = `${customTitle} — ${SITE_NAME}`;
    } else {
      document.title = PAGE_TITLES[pathname] || SITE_NAME;
    }
  }, [pathname, customTitle]);
};

export default usePageTitle;
